import { Button, Tabs } from 'flowbite-react';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { HiPlus } from 'react-icons/hi';
import InventoryDailyPriceListTable from './InventoryDailyPriceListTable';
import { useAppSelector } from '../../../Reducers/store';
import Loader from '../../Common/Loader';
import InventoryApi from '../../../Api/InventoryApi';
import { InventoryDailyPrice } from '../../../Models/InventoryDailyPrice';
import InventoryDailyPriceModal from './InventoryDailyPriceModal';
// import InventoryModal from './../InventoryModal';

export default function InventoryDailyPriceList() {
  const { userModel } = useAppSelector((state) => state.user);
  const [inventoryPriceListData, setinventoryPriceListData] = useState<
    InventoryDailyPrice[]
  >([]);
  const [selectedInventoryPrice, setselectedInventoryPricePrice] =
    useState<InventoryDailyPrice | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);

  const getInventoryDailyPriceList = useCallback(() => {
    if (userModel) {
      try {
        setIsLoading(true);
        return InventoryApi.getInventoryDailyPriceList()
          .then((res) => {
            setinventoryPriceListData(res.data);
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  }, [userModel]);

  useEffect(() => {
    getInventoryDailyPriceList();
  }, [getInventoryDailyPriceList]);

  // Separate current prices (most recent for each inventory type + state combo) from historical
  const { currentPrices, historicalPrices } = useMemo(() => {
    if (!inventoryPriceListData || inventoryPriceListData.length === 0) {
      return { currentPrices: [], historicalPrices: [] };
    }

    // Group prices by inventoryTypeId and stateId, keeping track of the most recent for each
    const priceMap = new Map<string, InventoryDailyPrice>();
    const allPrices: InventoryDailyPrice[] = [];

    inventoryPriceListData.forEach((price) => {
      const key = `${price.inventoryTypeId || 'null'}_${price.stateId || 'null'}`;
      const existing = priceMap.get(key);
      
      // If no existing price for this key, or this one is more recent, use this one
      if (!existing || !existing.dateOfPrice) {
        priceMap.set(key, price);
      } else if (price.dateOfPrice) {
        const existingDate = new Date(existing.dateOfPrice);
        const currentDate = new Date(price.dateOfPrice);
        if (currentDate > existingDate) {
          priceMap.set(key, price);
        }
      }
      
      allPrices.push(price);
    });

    // Get current prices (most recent for each combination), sorted by date desc
    const current = Array.from(priceMap.values()).sort((a, b) => {
      if (!a.dateOfPrice || !b.dateOfPrice) return 0;
      const dateA = new Date(a.dateOfPrice).getTime();
      const dateB = new Date(b.dateOfPrice).getTime();
      return dateB - dateA; // Descending order
    });
    
    // Get historical prices (everything else, sorted by date desc)
    const currentIds = new Set(current.map(p => p.id));
    const historical = allPrices
      .filter(p => !currentIds.has(p.id))
      .sort((a, b) => {
        if (!a.dateOfPrice || !b.dateOfPrice) return 0;
        const dateA = new Date(a.dateOfPrice).getTime();
        const dateB = new Date(b.dateOfPrice).getTime();
        return dateB - dateA; // Descending order
      });

    return { currentPrices: current, historicalPrices: historical };
  }, [inventoryPriceListData]);

  const handleAddInventoryClick = () => {
    setselectedInventoryPricePrice(null);
    setShowModal(true);
  };

  const editInventory = (inv: InventoryDailyPrice) => {
    setselectedInventoryPricePrice(inv);
    setShowModal(true);
  };

  function deleteInventory(id: number) {
    const shouldRemove = window.confirm(
      'Are you sure you want to delete this?'
    );

    if (shouldRemove) {
      // VendorApi.deleteInventory(id)
      //   .then((res) => {
      //     if (res.data.success) {
      //       toast.success(res.data.message);
      //       getInventory();
      //     } else {
      //       toast.success('Error while deleting item');
      //     }
      //   })
      //   .catch((err) => {
      //     toast.error('Error: ' + err);
      //   });
    }
  }
  function checkAccess() {
    if (userModel) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <div className='w-full'>
        <div className='w-full h-[74px] p-4'>
          <div className='mx-1 flex items-end'>
            <div className='flex flex-1'>
              <h1 className='text-gray-900 font-bold text-4xl'>
                <div>Daily Prices</div>
              </h1>
            </div>
            {checkAccess() && (
              <div className=''>
                <Button
                  onClick={handleAddInventoryClick}
                  className='buttonMain'
                >
                  <HiPlus size={20} />
                </Button>
              </div>
            )}
          </div>
        </div>
        <div className='w-full p-4 h-[calc(100vh-132px)] md:h-[calc(100vh-200px)] overflow-y-auto'>
          <div className='relative'>
            {isLoading && <Loader />}
            <Tabs style='fullWidth'>
              <Tabs.Item title='Current Prices' active>
                <InventoryDailyPriceListTable
                  data={currentPrices}
                  deleteInventory={deleteInventory}
                  editInventory={editInventory}
                />
              </Tabs.Item>
              <Tabs.Item title='Historical Prices'>
                <InventoryDailyPriceListTable
                  data={historicalPrices}
                  deleteInventory={deleteInventory}
                  editInventory={editInventory}
                />
              </Tabs.Item>
            </Tabs>
          </div>
        </div>
      </div>
      <InventoryDailyPriceModal
        show={showModal}
        setShow={setShowModal}
        getInventoryDailyPrices={getInventoryDailyPriceList}
        selectedInventoryPrice={selectedInventoryPrice}
      />
    </>
  );
}
